import type { AttachToConfig, CanvasJSONLikeObject } from '@doer/frontend-components/creativity-editor';
import { PAYMENT_METHOD_RULES } from '../data/payment-text-rules';
import { TEXT_DEFAULTS, type FontWeight } from './text-defaults';

export interface PaymentMethodTextOpts {
  pieceId: string;
  text: string;
  fontSize: number;
  fontWeight?: FontWeight;
  lineHeight: number;
  textAlign: 'left' | 'center' | 'right';
  position: { left: number; top: number; width: number; height: number };
  scaleX?: number;
  scaleY?: number;
  attachTo?: AttachToConfig;
  linkedAcrossResolutions?: boolean;
  fill?: string;
}

export function buildPaymentMethodText(opts: PaymentMethodTextOpts): CanvasJSONLikeObject {
  const {
    pieceId,
    text,
    fontSize,
    fontWeight = 'normal',
    lineHeight,
    textAlign,
    position,
    scaleX,
    scaleY,
    attachTo,
    linkedAcrossResolutions,
    fill = '#0030eb'
  } = opts;
  return {
    ...TEXT_DEFAULTS,
    type: 'Textbox',
    pieceId,
    text,
    fontSize,
    fontWeight,
    lineHeight,
    textAlign,
    textStyleRules: PAYMENT_METHOD_RULES,
    originY: 'center',
    left: position.left,
    top: position.top,
    width: position.width,
    height: position.height,
    scaleX: scaleX ?? 1,
    scaleY: scaleY ?? 1,
    fill,
    objectCaching: true,
    ...(attachTo ? { attachTo } : {}),
    ...(linkedAcrossResolutions !== undefined ? { linkedAcrossResolutions } : {})
  };
}
